export const ALLOWED_HOSTS = [
    'demo.anchor-hq.io',
    'app.sayanchor.com'
];
const ALLOWED_ANDROID_CALLBACK_SCHEMES = [
    'com.sayanchor.app',
    'com.sayanchor.app.staging'
];
const MAX_AUTH_TOKEN_LENGTH = 4096;
const MIN_AUTH_TOKEN_LENGTH = 16;
const MAX_STATE_LENGTH = 256;
const MAX_ERROR_LENGTH = 256;
const PATH_TO_PROVIDER = {
    '/qbo-integration/oauth-callback': 'qbo',
    '/xero-integration/oauth-callback': 'xero'
};
const ANDROID_SCHEME_HOST_TO_PROVIDER = {
    'qbo-integration': 'qbo',
    'xero-integration': 'xero'
};
export const ANDROID_SCHEME_CALLBACK_PATH = '/oauth-callback';
export const OAUTH_CALLBACK_PATHS = Object.keys(PATH_TO_PROVIDER);
export const androidCallbackHost = (provider)=>"".concat(provider, "-integration");
function resolveCallbackProvider(url) {
    if (url.protocol === 'https:') {
        var _PATH_TO_PROVIDER_url_pathname;
        return ALLOWED_HOSTS.includes(url.host) ? (_PATH_TO_PROVIDER_url_pathname = PATH_TO_PROVIDER[url.pathname]) !== null && _PATH_TO_PROVIDER_url_pathname !== void 0 ? _PATH_TO_PROVIDER_url_pathname : null : null;
    }
    if (ALLOWED_ANDROID_CALLBACK_SCHEMES.includes(url.protocol.slice(0, -1))) {
        var _ANDROID_SCHEME_HOST_TO_PROVIDER_url_host;
        return url.pathname === ANDROID_SCHEME_CALLBACK_PATH ? (_ANDROID_SCHEME_HOST_TO_PROVIDER_url_host = ANDROID_SCHEME_HOST_TO_PROVIDER[url.host]) !== null && _ANDROID_SCHEME_HOST_TO_PROVIDER_url_host !== void 0 ? _ANDROID_SCHEME_HOST_TO_PROVIDER_url_host : null : null;
    }
    return null;
}
export function isOAuthCallbackUrl(rawUrl) {
    try {
        return resolveCallbackProvider(new URL(rawUrl)) != null;
    } catch (unused) {
        return false;
    }
}
export function parseOAuthCallback(rawUrl) {
    var _fragment_get;
    let url;
    try {
        url = new URL(rawUrl);
    } catch (unused) {
        return {
            kind: 'ignored'
        };
    }
    const provider = resolveCallbackProvider(url);
    if (provider == null) {
        return {
            kind: 'ignored'
        };
    }
    const fragment = new URLSearchParams(url.hash.slice(1));
    const error = fragment.get('error');
    if (error != null && error.length <= MAX_ERROR_LENGTH) {
        return {
            kind: 'error',
            provider,
            error
        };
    }
    if (error != null) {
        return {
            kind: 'ignored'
        };
    }
    const state = (_fragment_get = fragment.get('state')) !== null && _fragment_get !== void 0 ? _fragment_get : '';
    if (state.length > MAX_STATE_LENGTH) {
        return {
            kind: 'ignored'
        };
    }
    const authToken = fragment.get('authToken');
    const isPlausibleToken = authToken != null && authToken.length >= MIN_AUTH_TOKEN_LENGTH && authToken.length <= MAX_AUTH_TOKEN_LENGTH;
    if (isPlausibleToken) {
        return {
            kind: 'success',
            provider,
            authToken,
            state
        };
    }
    return {
        kind: 'ignored'
    };
}
